<template>
  <LayoutActionCard
    :title="title"
    :subtitle="subtitle"
    :is-configured="isConfigured"
    :is-configure-active="isConfigureActive"
    :selected="selected"
    @delete="$emit('delete')"
    @configure="handleConfigure"
  >
    <template #icon>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM12 13H17V18H12V13Z" fill="#FFFFFF"/>
      </svg>
    </template>

    <template #content>
      <!-- Not Configured State -->
      <div v-if="!isConfigured" class="action-content">
        <!-- <div class="info-message">
          <img src="@/assets/MyWorkBench/Workflow/information_icon_circle.svg" style="width: 20px; height: 20px; margin-right: 4px;" />
          <span class="info-text">Send a message to the patient to request an appointment.</span>
        </div>

        <div class="form-field">
          <label class="field-label">Send Appointment Request</label>
          <TextareaWithClear
            v-model="localFormData.requestMessage"
            placeholder="For example: Dear patient, please book a meeting with me via this link ... &quot;"
            :max-length="1000"
            :rows="5"
            @update:modelValue="updateSharedData"
          />
        </div> -->
              </div>

      <!-- Configured State -->
      <div v-else class="action-content action-content--configured">
        <div class="config-row">
          <span class="config-label">Request Message: </span>
        </div>
        <div class="config-message">
          {{ displayRequestMessage }}
        </div>
              </div>
    </template>
  </LayoutActionCard>
</template>

<script>
import LayoutActionCard from './LayoutActionCard.vue';
import TextareaWithClear from '@/components/workflow/TextareaWithClear.vue';

export default {
  name: 'Appointment',
  components: {
    LayoutActionCard,
    TextareaWithClear
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete', 'configure'],
  data() {
    return {
      localFormData: {
        requestMessage: this.data.requestMessage || '',
        appointmentType: this.data.appointmentType || '',
        attendees: this.data.attendees || [],
        time: this.data.time || '',
        duration: this.data.duration || '',
        location: this.data.location || ''
      }
    };
  },
  computed: {
    title() {
      return 'Appointment';
    },
    subtitle() {
      return 'Schedule an appointment with the patient';
    },
    // Use savedData for display when available
    displayData() {
      return (this.data && this.data.savedData) ? this.data.savedData : this.data;
    },
    isConfigured() {
      return Boolean(this.displayData && this.displayData.configured);
    },
    isConfigureActive() {
      // Configure is active when request message has content
      return Boolean(this.localFormData.requestMessage && this.localFormData.requestMessage.trim().length > 0);
    },
    displayAppointmentType() {
      if (this.displayData && this.displayData.appointmentType) {
        return this.displayData.appointmentType;
      }
      return 'N/A';
    },
    displayAttendees() {
      if (this.displayData && this.displayData.attendees) {
        return Array.isArray(this.displayData.attendees) ? this.displayData.attendees.join(', ') : this.displayData.attendees;
      }
      return 'N/A';
    },
    displayTime() {
      if (this.displayData && this.displayData.time) {
        return this.displayData.time;
      }
      return 'N/A';
    },
    displayDuration() {
      if (this.displayData && this.displayData.duration) {
        return this.displayData.duration;
      }
      return 'N/A';
    },
    displayLocation() {
      if (this.displayData && this.displayData.location) {
        return this.displayData.location;
      }
      return 'N/A';
    },
    displayRequestMessage() {
      if (this.displayData && this.displayData.requestMessage) {
        return this.displayData.requestMessage;
      }
      return 'No message configured';
    }
  },
  watch: {
    'data.requestMessage': {
      handler(newVal) {
        if (newVal !== this.localFormData.requestMessage) {
          this.localFormData.requestMessage = newVal || '';
        }
      },
      immediate: true
    }
  },
  mounted() {
    // Initialize local form data from props if available
    if (this.data && this.data.requestMessage) {
      this.localFormData.requestMessage = this.data.requestMessage;
    }
    if (this.data && this.data.appointmentType) {
      this.localFormData.appointmentType = this.data.appointmentType;
    }
    if (this.data && this.data.attendees) {
      this.localFormData.attendees = this.data.attendees;
    }
    if (this.data && this.data.time) {
      this.localFormData.time = this.data.time;
    }
    if (this.data && this.data.duration) {
      this.localFormData.duration = this.data.duration;
    }
    if (this.data && this.data.location) {
      this.localFormData.location = this.data.location;
    }
  },
  methods: {
    handleConfigure() {

      this.$emit('configure', {
        requestMessage: this.localFormData.requestMessage
      });
    },
    updateSharedData() {
      // Update the shared data instance directly
      this.data.requestMessage = this.localFormData.requestMessage;
    }
  }
};
</script>

<style scoped>
.action-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

/* Info Message */
.info-message {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding: 4px 0;
}

.info-text {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
}

/* Form Field */
.form-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.field-label {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4A4A4A;
  height: 24px;
  display: flex;
  align-items: center;
}

/* Textarea */
.textarea-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
  padding: 8px 12px;
  transition: border-color 0.2s ease;
}

.textarea-container:focus-within {
  border-color: #004879;
}

.action-textarea {
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #333;
  border: none;
  outline: none;
  resize: none;
  min-height: 90px;
}

.action-textarea::placeholder {
  color: #999;
}

.textarea-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  margin-top: 4px;
}

.character-count {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #999;
}

.clear-btn {
  padding: 4px 10px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #1E4670;
  background: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
}

.clear-btn:hover {
  color: #004879;
}

/* Configured State */
.config-row {
  gap: 0;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
}

.config-row:last-child {
  margin-bottom: 0;
}

.config-label {
  font-weight: 700;
  color: #374957;
}

.config-value {
  font-weight: 400;
  color: #333;
}

.config-message {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
  padding: 8px 0px;
  background: #F9FAFB;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-word;
}

</style>
